export class ShimanoUtilMethod {
  static imageRendition(size: number) {
    return size <= 0 ? '' : '.thumb.' + size + '.' + size + '.png';
  }

  static newImageFormat(image: any, size: string) {
    let newImage: any = {};
    if (image) {
      if (typeof image.product !== 'undefined') {
        Object.keys(image.product).forEach((prop) => {
          if (prop === 'url') {
            newImage[prop] = image.product[prop].concat(size);
          } else {
            newImage[prop] = image.product[prop];
          }
        });
      } else if (typeof image.gallery !== 'undefined') {
        Object.keys(image.gallery).forEach((prop) => {
          if (prop === 'url') {
            newImage[prop] = image.gallery[prop].concat(size);
          } else {
            newImage[prop] = image.gallery[prop];
          }
        });
      } else if (typeof image === 'string') {
        newImage['url'] = image.concat(size);
      } else {
        Object.keys(image).forEach((prop) => {
          if (prop === 'url') {
            newImage[prop] = image[prop].concat(size);
          } else {
            newImage[prop] = image[prop];
          }
        });
      }
      return newImage;
    }
    return image;
  }

  static setMinimumOrderQuantity(value: any, moq: any) {
    const maxOrderQuantity = 999;
    let roundedValue = Math.round(value / moq) * moq;

    if (roundedValue > maxOrderQuantity) {
      roundedValue = roundedValue - moq;
    } else if (roundedValue < moq) {
      roundedValue = moq;
    }

    const finalValue = Math.min(roundedValue, maxOrderQuantity);
    return finalValue;
  }

  static checkUserQuantity(value: any, moq: any) {
    return value % moq;
  }

  static appendToStorage(name: any, data: any) {
    let old = sessionStorage.getItem(name);
    const empty: any = [];

    if (old == null) {
      sessionStorage.setItem(name, JSON.stringify(empty.concat(data)));
    } else {
      old = JSON.parse(old);
      sessionStorage.setItem(name, JSON.stringify(old.concat(data)));
    }
  }

  static removeToStorage(name: any, data: any) {
    let old = JSON.parse(sessionStorage.getItem(name));
    if (old !== null) {
      old = old.filter((item: any) => item !== data);
      const newData = JSON.stringify(old);
      sessionStorage.setItem(name, newData);
    }
  }

  static emailRegex() {
    return '^([\\w\\.-])+(?:\\.[a-z0-9]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$';
  }

  static isPropertyUndefined(prop: any) {
    return typeof prop !== 'undefined' ? false : true;
  }
  static isPropertyHasValue(prop: any) {
    return prop !== null && prop !== '' ? true : false;
  }

  static encodeObjectToBase64(obj: any) {
    const jsonString = JSON.stringify(obj);
    return btoa(jsonString);
  }

  static decodeBase64ToObject(base64: string) {
    const jsonString = atob(base64);
    return JSON.parse(jsonString);
  }
}
